import React, { ReactNode } from 'react';
import { Typography, Image } from 'tfc-components';

import Container from '../Container';

import lineWhite from 'assets/images/decor-title-white.png';
import line from 'assets/images/decor-title.png';
import mapModifiers from 'utils/functions';

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: ReactNode;
  className?: string;
}

const Section: React.FC<SectionProps> & { Title: React.FC<TitleProps> } = ({
  children,
  className = '',
  ...props
}) => (
  <section className={`o-section ${className}`} {...props}>
    <Container>
      {children}
    </Container>
  </section>
);

interface TitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode;
  className?: string;
  left?: boolean;
  small?: boolean;
  white?: boolean;
}

const Title: React.FC<TitleProps> = ({
  children, left, small, white, className = '', ...props
}) => (
  <>
    <Typography.Heading
      type="h2"
      extendClasses={`${mapModifiers('o-section_title', left && 'left', white && 'white')} 
      ${small ? 'f-28x34' : 'f-32x38'} ${className}`}
      {...props}
      fontweight="700"
    >
      {children}
    </Typography.Heading>
    <Image
      extendClasses="o-section_title_line"
      imgSrc={white ? lineWhite : line}
      alt="EVOL Labs"
      ratio={51 / 3}
    />
  </>
);

Section.Title = Title;

export default Section;
